import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "@shared/services/auth/auth.service";
import { catchError, from, switchMap, throwError } from "rxjs";

// The tokenInterceptor is an HTTP interceptor that automatically attaches the authentication token to outgoing requests.
// It also handles 401 Unauthorized errors by attempting to refresh the token and retrying the request.
// If the token refresh fails, it redirects the user to the login page.
export const tokenInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn) => {
    const authService: AuthService = inject(AuthService);
    const router: Router = inject(Router);

    let newRequest: HttpRequest<unknown> = request;

    // Add auth only for API calls that go to our backend (not external/static URLs).
    if (/*!request.url.includes(environment.urlserv) && */ !request.url.includes("amazonaws")) {
        const token: string | null = sessionStorage.getItem("accessToken");

        if (token) {
            newRequest = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`,
                },
            });
        }
    }

    return next(newRequest).pipe(
        catchError((error: HttpErrorResponse) => {
            // If the error is 401, then attempt to refresh the token and retry the request
            if (error.status === 401 && !newRequest.url.includes("/Account/refresh")) {
                return from(authService.refreshToken()).pipe(
                    switchMap(() => {
                        const newAccessToken: string | null = sessionStorage.getItem("accessToken");

                        newRequest = request.clone({
                            setHeaders: {
                                Authorization: `Bearer ${newAccessToken}`,
                            },
                        });

                        return next(newRequest);
                    }),
                    catchError((refreshError: HttpErrorResponse) => {
                        router.navigate(["/login"]);
                        return throwError(() => refreshError);
                    }),
                );

                // return authService
                //     .login(sessionStorage.getItem("email")!, sessionStorage.getItem("password")!)
                //     .pipe(
                //         switchMap((res: UserType) => {
                //             sessionStorage.setItem("token", res.token);

                //             const modifiedRequest = request.clone({
                //                 headers: request.headers.set("Authorization", `Bearer ${res.token}`),
                //             });

                //             // Retry the same call
                //             return next(modifiedRequest);
                //         }),
                //     );
            }

            return throwError(() => error);
        }),
    );
};
